<template>
  <section class="main-view">
    <el-scrollbar class="main-scrollbar">
      <div class="global-container relative-container">
        <div class="absolute-left hidden-sm-and-down layout-menu">
          <commonMenu />
        </div>
        <div class="content-right layout-content">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
          <!-- <transition name="custom-classes-transition"  mode="out-in" enter-active-class="animated slideInRight" leave-active-class="animated slideOutLeft">
         <router-view :key="key"></router-view>
          </transition>-->
        </div>
      </div>
    </el-scrollbar>
  </section>
</template>
<script>
import Ffooter from "./footer";
import commonMenu from "@/components/menu";
export default {
  name: "mainView",
  data() {
    return {
      transitionEnter: "animated slideInRight",
      transitionLeave: "animated slideOutLeft",
    };
  },
  components: {
    Ffooter,
    commonMenu,
  },
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.main-view {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100%;
  background-color: $common_bg;
  overflow: auto;
  .main-page {
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    padding-bottom: 80px;
  }
  .footer {
    margin-top: 0;
  }
  .layout-menu{
    padding-top: 40px;
  }
  .layout-content{
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
</style>
<style lang="scss">
.main-view {
  .main-scrollbar {
    width: 100%;
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
}
</style>

